import { Draggable } from "@hello-pangea/dnd";
import React from "react";

import ReleaseLabel from "../../ReleaseLabel";

import { Label } from "./types";

import { BasicTooltip } from "@/components/ui/Tooltip";

interface DraggableReleaseLabelProps {
  label: Label;
  index: number;
  isActiveVersion: boolean;
  onConfigure?: (label: Label) => void;
  readOnly?: boolean;
  pendingDeleteChangelogId?: number;
  onPendingDeleteClick?: (changelogId: number) => void;
}

const DraggableReleaseLabel: React.FC<DraggableReleaseLabelProps> = ({
  label,
  index,
  isActiveVersion,
  readOnly,
  onConfigure,
  pendingDeleteChangelogId,
  onPendingDeleteClick,
}) => {
  const hasPendingDelete = pendingDeleteChangelogId !== undefined;

  const handleClick = () => {
    if (!readOnly && onConfigure) {
      onConfigure(label);
    }
  };

  const handlePendingDeleteClick = () => {
    if (hasPendingDelete && onPendingDeleteClick) {
      onPendingDeleteClick(pendingDeleteChangelogId);
    }
  };

  return (
    <Draggable
      draggableId={`label-${label.id}-${label.name}`}
      index={index}
      isDragDisabled={readOnly}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`relative w-auto max-w-full ${snapshot.isDragging ? "z-50" : ""}`}
        >
          {hasPendingDelete ? (
            <BasicTooltip content="Pending delete request">
              <div>
                <ReleaseLabel
                  label={label}
                  variant="pending-delete"
                  onClick={handleClick}
                  onPendingDeleteClick={handlePendingDeleteClick}
                  isDragging={snapshot.isDragging}
                  readOnly={readOnly}
                  showDeleteButton={false}
                  activeBackground={isActiveVersion ? "bg-blue-100" : "bg-white"}
                />
              </div>
            </BasicTooltip>
          ) : (
            <ReleaseLabel
              label={label}
              variant="default"
              onClick={handleClick}
              isDragging={snapshot.isDragging}
              readOnly={readOnly}
              showDeleteButton={false}
              activeBackground={isActiveVersion ? "bg-blue-100" : "bg-white"}
            />
          )}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableReleaseLabel;
